import { createAsyncThunk } from "@reduxjs/toolkit";
import sdkProvider from "../../../../client/sdkProvider";
import logger from "../../../../lib/logger";
import getEnableComplianceVariantFromConfig from "../selectors/getEnableComplianceVariantFromConfig";

const loadEnableComplianceVariant = createAsyncThunk(
  "config/loadEnableComplianceVariant",
  async (_, { rejectWithValue }) => {
    try {
      const loyaltySdk = await sdkProvider("loyalty");
      const config = await loyaltySdk.getConfig();

      return getEnableComplianceVariantFromConfig(config);
    } catch (error) {
      if (error.name !== "LoyaltyNotSupportedError") {
        error.message = `loadEnableComplianceVariant failed with error: ${error.message}`;
        logger.error(error);
      }

      return rejectWithValue(error);
    }
  }
);

export default loadEnableComplianceVariant;
